import {
  Alert,
  Autocomplete,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Tooltip,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { getData } from "../../../../../services/library";
import { UrlApi } from "../../../../../services/apirest";
import { debounce } from "lodash";
import SelectorFiltrosMultiples from "../../../pedidosEnvasado/NuevoPedido/agregados/SelectorFiltrosMultiples";
import ChipsFiltrosActivos from "../../../pedidosEnvasado/NuevoPedido/agregados/ChipsFiltrosActivos";
import TabAltaEnv from "../../../clientesEnvasado/alta/TabAltaEnv";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import DeleteIcon from '@mui/icons-material/Delete';

function AgregarClienteAsociado(props) {
  const [alta, setAlta] = useState(props.alta);
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [direcciones, setDirecciones] = useState(null);
  const [direccionSeleccionada, setDireccionSeleccionada] = useState("");
  const [clientesAgregados, setClientesAgregados] = useState([]);
  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColormensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [searchCliente, setSearchCliente] = useState("");
  const [tabla, setTabla] = useState(true);
  const [altaCliente, setAltaCliente] = useState(false);
  const [disBtn, setDisBtn] = useState(true);
  
  // Estados para el sistema de búsqueda
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState([
    "cliente",
    "direccion",
  ]);
  const [todasDirecciones, setTodasDirecciones] = useState([]);
  const [loadingDirecciones, setLoadingDirecciones] = useState(false);
  const [inputValueDirecciones, setInputValueDirecciones] = useState("");

  // Opciones de filtros
  const opcionesFiltros = [
    { value: "cliente", label: "👤 Cliente", icon: "👤" },
    { value: "direccion", label: "🏠 Dirección", icon: "🏠" },
    { value: "localidad", label: "🏙️ Localidad", icon: "🏙️" },
    { value: "telefono", label: "📞 Teléfono", icon: "📞" },
    { value: "cuit", label: "📋 CUIT", icon: "📋" },
    { value: "sisven", label: "🔢 SISVEN", icon: "🔢" },
  ];

  const handleFiltrosChange = (nuevosFiltros) => {
    setFiltrosSeleccionados(nuevosFiltros);
  };

  // Función para buscar direcciones con filtros (EXACTAMENTE LA MISMA)
  const buscarDireccionesFiltradas = async (searchTerm, filtros) => {
    if (!searchTerm || searchTerm.trim().length < 2 || filtros.length === 0) {
      setTodasDirecciones([]);
      return;
    }

    setLoadingDirecciones(true);
    try {
      // Verificamos si existe props.hoja, si no, usamos un array vacío
      const sucursales = props.datosRow?.id_sucursal || [];
      const searchParams = new URLSearchParams({
        search: searchTerm.trim(),
        limit: 100,
        filtros: filtros.join(","),
      });

      const response = await fetch(
        UrlApi +
          `/envasado_direcciones_entrega/buscarDireccionesSucAuth/${sucursales}?${searchParams}`
      );

      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      setTodasDirecciones(data);
    } catch (error) {
      console.error("Error buscando direcciones:", error);
      setTodasDirecciones([]);
    } finally {
      setLoadingDirecciones(false);
    }
  };

  // Debounce para búsqueda
const debouncedSearch = useCallback(
  debounce((searchTerm, filtros) => {
    buscarDireccionesFiltradas(searchTerm, filtros);
  }, 400),
  [props.datosRow, props.clientesAsociados] // ← NUEVAS DEPENDENCIAS
);

  // Placeholder dinámico
  const getPlaceholderText = (filtros) => {
    if (filtros.length === 0) {
      return "Seleccione filtros para buscar...";
    }

    if (filtros.length === opcionesFiltros.length) {
      return "Buscar en todos los campos...";
    }

    const filtrosLabels = filtros.map((filtro) => {
      const opcion = opcionesFiltros.find((f) => f.value === filtro);
      return opcion?.label
        .toLowerCase()
        .replace("por ", "")
        .replace(/[👤🏠🏙️📞📋🔢]/g, "")
        .trim();
    });

    return `Buscar por: ${filtrosLabels.join(", ")}...`;
  };

  useEffect(() => {
    if (inputValueDirecciones.length >= 2 && filtrosSeleccionados.length > 0) {
      debouncedSearch(inputValueDirecciones, filtrosSeleccionados);
    } else {
      setTodasDirecciones([]);
    }

    return () => {
      debouncedSearch.cancel();
    };
  }, [inputValueDirecciones, filtrosSeleccionados, debouncedSearch]);

  // Manejo de selección de dirección
  const handleDireccionSeleccionada = (newValue) => {
    if (!newValue) {
      setDireccionSeleccionada("");
      setClienteSeleccionado("");
      return;
    }

    setDireccionSeleccionada(newValue);

    if (newValue && newValue.id_cliente) {
      const clienteAsociado = {
        id: newValue.id_cliente,
        razon_social: newValue.razon_social,
        sisven_id: newValue.sisven_id,
        sucursal: newValue.cliente_sucursal || newValue.sucursal,
        cuit: newValue.cuit,
        localidad: newValue.localidad
      };

      setClienteSeleccionado(clienteAsociado);

      // Obtener todas las direcciones del cliente (si es necesario)
      if (newValue.id_cliente) {
        getData(
          "/envasado_direcciones_entrega/cli/" + newValue.id_cliente,
          setDirecciones
        );
      }
    }
  };

  const clienteYaAsociado = (id_cliente) => {
  return props.clientesAsociados?.some(cliente => cliente.id === id_cliente) || false;
};

const handleAgregarCliente = (direccion) => {
  if (!clienteSeleccionado || !direccion) return;

  // Verificar si el cliente ya está en clientesAsociados
  if (clienteYaAsociado(clienteSeleccionado.id)) {
    setColormensaje("#F5B041");
    setMensaje("Este cliente ya está asociado");
    setOpenSnack(true);
    
    // Reset
    setClienteSeleccionado("");
    setDireccionSeleccionada("");
    setInputValueDirecciones("");
    setTodasDirecciones([]);
    return;
  }

  // Verificar si ya existe en la lista actual de agregados
  const existe = clientesAgregados.find(
    (item) =>
      item.cliente.id === clienteSeleccionado.id &&
      item.direccion.id === direccion.id
  );

  if (existe) {
    setColormensaje("#F5B041");
    setMensaje("Este cliente ya está en la lista");
    setOpenSnack(true);
    return;
  }

  // Buscar el cliente completo en props.clientesAsociados para obtener entrega_con_remito
  const clienteCompleto = props.clientesAsociados?.find(c => c.id === clienteSeleccionado.id);

  setClientesAgregados((prev) => [
    ...prev,
    { 
      cliente: {
        ...clienteSeleccionado,
        entrega_con_remito: direccion?.entrega_con_remito,
        facturar_a: direccion?.facturar_a
      }, 
      direccion: {
        id: direccion.id,
        direccion_entrega: direccion.direccion_entrega,
        localidad: direccion.localidad,
        latitud: direccion.latitud,
        longitud: direccion.longitud
      } 
    },
  ]);

  // Reset
  setClienteSeleccionado("");
  setDireccionSeleccionada("");
  setDirecciones(null);
  setInputValueDirecciones("");
  setTodasDirecciones([]);
};
  useEffect(() => {
    if (direccionSeleccionada) {
      handleAgregarCliente(direccionSeleccionada);
    }
  }, [direccionSeleccionada]);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
  };

  const handleClose = () => {
    setAlta(!alta);
    if (props.onClose) props.onClose();
  };

  const handleEliminarCliente = (index) => {
    setClientesAgregados((prev) => prev.filter((_, i) => i !== index));
  };

const handleGuardar = async (e) => {
  e.preventDefault();
  setDisBtn(true);
  
  try {
    // Crear un array de promesas para todas las actualizaciones
    const actualizaciones = clientesAgregados.map(async (item) => {
      const clienteId = item.cliente.id;
      
      // Preparar los datos para actualizar
      const datosActualizar = {
        entrega_con_remito: 1,
        facturar_a: props.datosRow.id,
        // updated_at: new Date().toISOString()
      };

      console.log(`Actualizando cliente ${clienteId}:`, datosActualizar);

      // Hacer el PUT a la API
      const response = await fetch(`${UrlApi}/envasado_clientes/${clienteId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosActualizar)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error actualizando cliente ${clienteId}: ${errorData.message || response.statusText}`);
      }

      return await response.json();
    });

    // Esperar a que todas las actualizaciones se completen
    const resultados = await Promise.all(actualizaciones);
    console.log('Actualizaciones completadas:', resultados);

    setColormensaje("#58D68D");
    setMensaje(`Clientes actualizados correctamente (${clientesAgregados.length})`);
    setOpenSnack(true);

    // reset
    setClientesAgregados([]);
    setInputValueDirecciones("");
    
    if (props.onSuccess) {
      props.onSuccess(clientesAgregados);
    }
    
    setTimeout(() => {
      handleClose();
    }, 1500);
    
  } catch (err) {
    console.error('Error en actualizaciones:', err);
    setColormensaje("#EC7063");
    setMensaje(`Error: ${err.message || "Hubo un error al actualizar"}`);
    setOpenSnack(true);
  } finally {
    setDisBtn(false);
  }
};

  useEffect(() => {
    setDisBtn(clientesAgregados.length === 0);
  }, [clientesAgregados]);

const ClientesSeleccionadosList = React.memo(
  ({ clientesFiltrados, handleEliminarCliente }) =>
    clientesFiltrados.map((item, index) => {
      // Buscar el cliente completo en props.clientesAsociados para obtener entrega_con_remito y facturar_a
    //   const clienteCompleto = props.clientesAsociados?.find(c => c.id === item.cliente.id);
      const entregaConRemito = item?.cliente.entrega_con_remito === 1;
      const facturarA = item?.cliente.facturar_a;
      
      return (
        <Box
          key={`${item.cliente.id}-${item.direccion.id}-${index}`}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
            padding: "8px",
            backgroundColor: index % 2 === 0 ? "transparent" : "rgba(0,0,0,0.02)",
            borderRadius: "4px",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography fontSize={16} fontWeight="500">
              {item.cliente.razon_social}
            </Typography>
            
            {/* Mostrar la dirección */}
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              📍 {item.direccion.direccion_entrega} - {item.direccion.localidad}
            </Typography>
            
            {/* Mostrar información adicional en una línea */}
            <Box sx={{ display: "flex", gap: 2, mt: 0.5, flexWrap: "wrap" }}>
              <Typography variant="caption" color="text.secondary">
                CUIT: {item.cliente.cuit || "—"}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                SISVEN: {item.cliente.sisven_id || "—"}
              </Typography>
              
              {/* Mostrar ENTREGA CON REMITO si corresponde */}
              {entregaConRemito && (
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: "#e67e22",
                    fontWeight: "bold",
                    backgroundColor: "#fef5e7",
                    padding: "2px 8px",
                    borderRadius: "4px",
                  }}
                >
                   ENTREGA CON REMITO {facturarA ? `(Facturar a: ${facturarA})` : ''}
                </Typography>
              )}
            </Box>
          </Box>
          
          <Tooltip title="Eliminar">
            <IconButton
              size="small"
              onClick={() => handleEliminarCliente(index)}
            >
              <DeleteIcon fontSize="small" color="error"/>
            </IconButton>
          </Tooltip>
        </Box>
      );
    })
);

  return (
    <>
      {tabla && (
        <Dialog fullWidth open={alta} onClose={handleClose} maxWidth="md">
          <Box justifyContent="center" backgroundColor="#1F618D">
            <DialogTitle>
              <Typography fontSize={20} align="center" color="#ffffff">
                {props.titulo || "Agregar Clientes Asociados"}
              </Typography>
            </DialogTitle>
          </Box>
          <form autoComplete="off" onSubmit={handleGuardar}>
            <DialogContent>
              <Grid container spacing={2}>
                {/* Sistema de búsqueda unificado - EXACTAMENTE IGUAL AL ORIGINAL */}
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    <Grid container spacing={1} alignItems="center">
                      {/* Selector de filtros */}
                      <Grid item xs={12} sm="auto">
                        <Box sx={{ minWidth: 160, height: 40 }}>
                          <SelectorFiltrosMultiples
                            filtrosSeleccionados={filtrosSeleccionados}
                            onFiltrosChange={handleFiltrosChange}
                          />
                        </Box>
                      </Grid>

                      {/* Campo de búsqueda */}
                      <Grid item xs={12} sm>
                        <Autocomplete
                          loading={loadingDirecciones}
                          required
                          disableClearable
                          inputValue={inputValueDirecciones}
                          id="buscar-direccion"
                          size="small"
                          loadingText="Buscando..."
                          noOptionsText={
                            inputValueDirecciones.length < 2
                              ? "Escriba al menos 2 caracteres..."
                              : filtrosSeleccionados.length === 0
                              ? "Seleccione al menos un filtro"
                              : loadingDirecciones
                              ? "Buscando..."
                              : "No se encontraron resultados"
                          }
                          options={todasDirecciones}
                          autoHighlight
                          filterOptions={(options) => options}
                          getOptionLabel={(direccion) =>
                            direccion
                              ? `${direccion.direccion_entrega} - ${direccion?.localidad}`
                              : ""
                          }
                          isOptionEqualToValue={(option, value) =>
                            option?.id === value?.id
                          }
                          value={direccionSeleccionada}
                          onChange={(event, newValue) => {
                            handleDireccionSeleccionada(newValue);
                          }}
                          onInputChange={(event, newInputValue) => {
                            setInputValueDirecciones(newInputValue);
                          }}
                          renderOption={(props, option) => (
                            <Box component="li" {...props} sx={{ py: 1.5 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    backgroundColor: "primary.main",
                                    flexShrink: 0,
                                  }}
                                />
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight="600"
                                    noWrap
                                  >
                                    {option.direccion_entrega}
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                      mt: 0.5,
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      {option.localidad}
                                    </Typography>
                                    <Box
                                      sx={{
                                        width: 3,
                                        height: 3,
                                        borderRadius: "50%",
                                        backgroundColor: "grey.400",
                                      }}
                                    />
                                    <Typography
                                      variant="caption"
                                      color="text.primary"
                                      fontWeight="500"
                                    >
                                      {option.razon_social}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={getPlaceholderText(
                                filtrosSeleccionados
                              )}
                              label="Buscar cliente/dirección"
                              size="small"
                              error={filtrosSeleccionados.length === 0}
                              helperText={
                                filtrosSeleccionados.length === 0
                                  ? "Seleccione al menos un filtro"
                                  : ""
                              }
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  height: 40,
                                },
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {loadingDirecciones ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={16}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>

                    {/* Chips de filtros activos */}
                    <ChipsFiltrosActivos
                      filtrosSeleccionados={filtrosSeleccionados}
                      onFiltrosChange={handleFiltrosChange}
                    />
                  </Box>
                </Grid>

                {/* Listado de clientes agregados */}
                <Grid item xs={12}>
                  {clientesAgregados.length > 0 ? (
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "10px",
                        backgroundColor: "#f9f9f9",
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}
                    >
                      <Grid container spacing={1} mb={1}>
                        <Grid item xs={6}>
                          <Typography
                            fontSize={18}
                            fontWeight="bold"
                            color="#1F618D"
                          >
                            Clientes Seleccionados:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            size="small"
                            type="search"
                            placeholder="Filtrar lista..."
                            value={searchCliente}
                            onChange={(e) => setSearchCliente(e.target.value)}
                          />
                        </Grid>
                      </Grid>

                      <ClientesSeleccionadosList
                        clientesFiltrados={clientesAgregados.filter(
                          (item) =>
                            item.cliente.razon_social
                              .toLowerCase()
                              .includes(searchCliente.toLowerCase()) ||
                            item.direccion.direccion_entrega
                              .toLowerCase()
                              .includes(searchCliente.toLowerCase())
                        )}
                        handleEliminarCliente={handleEliminarCliente}
                      />
                    </Box>
                  ) : (
                    <Typography
                      fontSize={16}
                      color="gray"
                      textAlign="center"
                      py={2}
                    >
                      No hay clientes seleccionados.
                    </Typography>
                  )}
                </Grid>
                
                {/* Botones de acción */}
                <Grid container justifyContent="space-between" mt={1}>
                  <Grid>
                    <Button
                      color="error"
                      variant="outlined"
                      onClick={handleClose}
                      style={{ backgroundColor: "#fff" }}
                    >
                      Volver
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      type="submit"
                      color="success"
                      variant="contained"
                      disabled={disBtn}
                    >
                      Guardar ({clientesAgregados.length})
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
          </form>
        </Dialog>
      )}
      
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarClienteAsociado;